import {ErrorEvent} from '../../../api/network';
import {IMCMethodResponse} from '../../../api/proto';
import getCreateChannelError from './getCreateChannelError';
import getDropChannelError from './getDropChannelError';

export const getChannelActionError = (res?: IMCMethodResponse | null): ErrorEvent | null => {
  if (res?.createChannel) {
    return getCreateChannelError(res?.createChannel);
  } else if (res?.dropChannel) {
    return getDropChannelError(res?.dropChannel);
  }

  return null;
};

export default getChannelActionError;